import React, { useState, useEffect } from "react";
import Navbar from "../../components/template/Navbar";
import Template from "../../components/template/Template";
import { Button } from "antd";
import { IoRefreshOutline } from "react-icons/io5";
import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import Cookies from "js-cookie";

function ReportDailyTask(props) {
  
  return (
    <div>
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#303030" }}>
            Tugas Harian
          </div>
          <Button
            style={{
              border: "1px solid #DCDCDC",
              borderRadius: 5,
              height: 36,
              width: 120,
            }}
          >
            <div style={{ color: "#2C465C" }}>
              <IoRefreshOutline style={{ margin: 5 }} />
              Refresh
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ReportDailyTask;
